<template>
  <b-container fluid class="py-3">
    <b-row>
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty v-if="items.length === 0" eheader="PrePayment" econtent="PrePayment"
            eimg="/src/assets/Img/icons/supplier-mapping.svg" :createline="true" @createNew="showprepayment" />

          <Tableview v-if="items.length !== 0" v-model:value="items" :paginator="true" class="p-datatable-gridlines"
            :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
            :columns="headers" dataKey="ID" :selectionMode="false" :addnewbtn="true" @row-click="RowClick">
            <template v-slot:Add v-if="!showprepayadjust">
              <span class="add">
                <AddButton :btnname="$t('btn.plusaddnew')" class="float-rights me-3" @click="showprepayment">
                </AddButton>
              </span>
            </template>
            <template v-slot:status="{ data }">
              <OrangeStatus name="Pending" v-if="data.Status == '0'" />
              <GreenStatus name="Partially" v-if="data.Status == '3'" />
              <GreenStatus name="Applied" v-if="data.Status == '4'" />
            </template>
            <template v-slot:ApprovalstatusSlot="{ data }">
              <OrangeStatus name="Approval Pending" v-if="data.IsApproved == '0'" />
              <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
              <OrangeStatus name="Payment Pending" v-if="data.IsApproved == '2'" />
              <RedStatus name="Approval Rejected" v-if="data.IsApproved == '3'" />
            </template>

            <template v-slot:action="{ data }">
              <span class="add" v-if="showprepayadjust">
                <Button label="Apply" class="" />
              </span>
              <span v-else>
                <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                  @click="toggle($event, data)" />
              </span>
            </template>
          </Tableview>
          <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
        </div>
      </b-col>
    </b-row>
  </b-container>

  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />

  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <PrePaymentCreationPopup :datas="datas" v-model:showprepayDialog="showprepayDialog" v-model:selected-item="editItems"
    v-if="showprepayDialog" @closepopup="IsClear" @load="IsShow" />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch, toRef } from "vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import { useI18n } from "vue-i18n";
import SupplierPaymentService from "../../../../../../modules/Inventory/Service/SupplierPrePayment";
import PrePaymentCreationPopup from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/PrePaymentCreation.vue";
import paginator from "../../../../../../components/FormComponents/paginator.vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  components: {
    Tableview,
    SkeletonTableLoader,
    MasterEmpty,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    PrePaymentCreationPopup,
    Mapping,
  },
  props: {
    datas: {
      type: Array,
      default: [],
    },
    showprepayadjustment: {
      //   readonly: false,
      type: Boolean,
      default: false,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    PrePaymetStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    onMounted(() => {
      supplierdatas.value = props.datas;
      showprepayadjust.value = props.showprepayadjustment;
      IsShow();
    });
    const route = useRoute();

    //Declaration
    const { t } = useI18n();
    const deletepop = ref(false);
    const Editmodel = ref(false);
    const Deletemodel = ref(false);
    // const showprepayadjust = toRef(props, "showprepayadjustment");
    const showprepayadjust = ref(props.showprepayadjustment);
    const contentdel = ref("");
    const items = ref([]);
    const emititems = ref([]);
    const getdatas = ref();
    const supplierdatas: any = ref([]);
    const menu = ref();
    const dataEdit = ref();
    const editItems = ref();
    const activeTabIndex = ref(props.activeIndex);
    const toggle = (event, data) => {
      getdatas.value = data;
      menu.value.toggle(event);
    };
    const MappingPop = ref({
      visible: false,
      content: "",
    });
    let UserData = ref();
    UserData.value = localStorage.getItem("UsersData");
    UserData.value = JSON.parse(UserData.value);
    let branchid = Number(UserData.value.BranchId);
    let hospitalid = Number(UserData.value.HospitalId);
    const showprepayDialog = ref(false);
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: true,
            command: async () => {
              IsConfirmEdit(getdatas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(getdatas.value, 0);
            },
          },
        ],
      },
    ]);

    watch(
      () => props.datas,
      (newVal: any) => {
        activeTabIndex.value = 0
        supplierdatas.value = newVal;
        IsShow();
      },
      { deep: true }
    );

    watch(
      () => props.showprepayadjustment,
      (newValue) => {
        // showprepayadjust.value = newValue;
        // IsShow();
      },
      { deep: true }
    );

    watch(
      () => props.activeIndex,
      (newVals: any) => {
        IsShow();
      },
      { deep: true }
    );
    watch(
      () => props.PrePaymetStatus,
      (newVal: any) => {
        IsShow();
      }, { deep: true }
    );
    const loading = ref(false);
    //DataTable Fields
    const headers = [
      {
        header: "S.No",
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: "Prepayment Id",
        field: "Code",
        class: "filterdisplaynone",
      },
      {
        header: "Prepayment Date",
        field: "PaymentDate",
        filterTemplate: "MultiSelect",
        hide: showprepayadjust.value,
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Amount",
        field: "Amount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },

      {
        header: "Against PO Id",
        field: "POCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Status",
        field: "Status",
        slot: "status",
        fieldDisplay: "false",
        hide: showprepayadjust.value,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Approval Status",
        field: "Status",
        slot: "ApprovalstatusSlot",
        fieldDisplay: "false",
        hide: showprepayadjust.value,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone columnfreeze",
        fieldDisplay: "false",
      },
    ];

    function showprepayment() {
      showprepayDialog.value = true;
    }

    function IsClear() {
      showprepayDialog.value = false;
      IsShow();
    }
    function closetrigger() {
      MappingPop.value.visible = false;
      deletepop.value = false;
      deletepop.value = false;
      IsShow();
    }

    async function IsShow() {
      try {
        loading.value = true;
        let count = 0;
        const dataresponse = await SupplierPaymentService.GetBySupplierId(hospitalid, branchid, supplierdatas.value.SupplierId, route.query.StoreBranchMapId);
        if (showprepayadjust.value == true) {
          items.value = dataresponse["result"]
            .filter(
              (item) =>
                item["Status"] == 0
            )
            .map((item: any) => {
              count = count + 1;
              item.RowNumber = count;
              item.ApprovalStatus = item.IsApproved
              item.PaymentID = item.PrepaymentID
              item.ApprovalType = 2
              return item;
            });
        } else {
          items.value = dataresponse["result"]
            .map((item: any) => {
              count = count + 1;
              item.RowNumber = count;
              item.ApprovalStatus = item.IsApproved
              item.PaymentID = item.PrepaymentID
              item.ApprovalType = 2
              return item;
            });
        }
        console.log(items.value);
        loading.value = false;
        SendPrePayment();
      } catch (error) {
        console.log(error);
      }
    }
    function SendPrePayment() {
      emititems.value = items.value.filter((item) => item["Status"] == 0);
      console.log(items.value);
      console.log(emititems.value);
      emit('updatedprepayment', emititems.value);
    }
    function IsConfirmDel(data, Status) {
      dataEdit.value = data;
      // Editmodel.value = false;
      if (Status == 0) {
        contentdel.value = t("confirmation.deletecontent");
      }
      Deletemodel.value = true;
    }
    async function IsDelete(data) {
      loading.value = true;
      try {
        let result: any = "";
        if (data.Status == 0) {
          result = await SupplierPaymentService.DeleteData(data.PrepaymentID);
        }
        let message = result["ErrorInfo"].ErrorCode;

        if (result["result"] != false && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = result["result"];
          MappingPop.value.visible = true;
        } else if (message == null) {
          Deletemodel.value = false;
          deletepop.value = true;
        }
      } catch (error) {
        loading.value = false;
      }
    }
    function IsConfirmEdit(data) {
      dataEdit.value = data;
      Editmodel.value = true;
    }
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      Editmodel.value = false;
      showprepayDialog.value = true;
    }
    function RowClick(event: any) {

      emit("ApprovalDetailsData", event.data);
    }
    return {
      items,
      emititems,
      loading,
      headers,
      showprepayment,
      closetrigger,
      supplierdatas,
      IsShow,
      toggle,
      menu,
      itemListed,
      deletepop,
      Editmodel,
      Deletemodel,
      contentdel,
      getdatas,
      dataEdit,
      IsConfirmDel,
      IsDelete,
      MappingPop,
      IsConfirmEdit,
      showprepayDialog,
      IsClear,
      IsEdit,
      editItems,
      showprepayadjust,
      activeTabIndex,
      SendPrePayment,
      RowClick
    };
  },
});
</script>

<style lang="scss" scoped></style>
